import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions } from 'vuex'

export default {

    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            hasError: false,
            identification: '',
            password: '',
            loading: false,
            isShowModal: false,
            check: false,
            closemodal: false
        }
    },
    created() {
        // let check = localStorage.getItem('check')
        // if (!check)
        //     this.load();
        this.loading = true
        const identification = this.$route.query.identification
        const identificationType = this.$route.query.identificationType
        // console.log(token)
        this.loginToken3({ identificationType, identification }).then((result) => {
            if (result.data === 'No consentido') {
                this.loading = false
                this.$buefy.toast.open({ message: 'Verifica que la información ingresada sea correcta. Si necesitas solicitar los medicamentos para una persona priorizada por EPS SURA, debes ingresar sus datos', type: 'is-danger', duration: 20000 })
            } else {
                this.loading = false
                this.$router.push('/home')
            }
        }).catch((error) => {
            this.loading = false
            window.location = process.env.SURA_URL;
            // if (error.statusCode == 404 || error.statusCode == 409) {
            //     this.$buefy.toast.open({ message: this.$t('app.components.login.invalid-user-or-password'), type: 'is-danger' })
            // }
        });
    },
    methods: {
        ...mapActions('auth', ['login', 'loginToken', 'loginToken2', 'loginToken3']),
        load() {
            if (this.check === true) {
                this.isShowModal = false
                localStorage.setItem('modal', this.isShowModal)
            }
        },

        submit() {
            let { identification, password } = this;
            this.loading = true

            this.login({ identification, password }).then((result) => {
                this.loading = false
                this.$router.push('/home')
            }).catch((error) => {
                this.loading = false
                if (error.statusCode == 404 || error.statusCode == 409) {
                    this.$buefy.toast.open({ message: this.$t('app.components.login.invalid-user-or-password'), type: 'is-danger' })
                }
            });

        },


    }
}